<script>
  import { formatMoney, ignore } from '../../Common/tools';
  import { onMount } from 'svelte';
  import { External, M } from '../../external';
  import { enableAddon, getMarketingEmailsAddon, LABELS } from './addons';

  export let onChange = ignore, onCancel = ignore, addon = null, type, subscription;

  let loading = false;

  let activateAddon = async () => {
    if (loading) {
      return;
    }
    loading = true;
    let result = await enableAddon(addon, 1);
    loading = false;
    if (result.ok) {
      External.Tools.showAutohideMessage(1500, M.ADDON_ENABLED);
      onChange(result.data);
    }
  };


  onMount(() => {
    if (type === 'MARKETING_EMAILS') {
      addon = getMarketingEmailsAddon(subscription);
    } else {
      addon = External.Website.addons.find(addon => addon.type === type);
    }
  });
</script>
<div class="popup-widget-wrapper" style="overflow-x: hidden">
  <div class="col20 f-left t-left flex align-center flex-col">
    <h2 class="col20 f-left mt-15 t-center big-title-popup">{LABELS[type].title}</h2>
    <div class="col12 f-left t-center mt-10 light-gray-text f-14-regular">{LABELS[type].description}</div>
  </div>

  {#if addon}
    <div class="price-tables-wrapper table-of-one style-1 layout-2 col20 f-left mt-15">
      <div class="price-table most-popular highlight-table">
        <div class="price-table-inner">
          <h3 class="price-table-value monthly">
            {@html formatMoney(addon.monthlyPrice || 0, subscription.currency, true, true)}
            <span class="col20 f-left mt-5 price-table-support-text">{LABELS[type].meteredPricingLabel}</span>
          </h3>
          <div class="price-table-description">
            <ul class="icon-list-wrapper">
              {#each LABELS[type].features as feature}
                <li class="icon-list-item">
                  <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                    <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                  </svg>
                  <span class="icon-list-name">{feature}</span>
                </li>
              {/each}
            </ul>
          </div>
          <div class="price-table-footer">
            <a class="price-table-button" on:click={activateAddon}>
              {M.ACTIVATE}
              <svg xmlns="http://www.w3.org/2000/svg" class="price-table-arrow" height="48" viewBox="0 -960 960 960" width="48">
                <path
                  d="m695.461-314.463-32.615-31.999 109.847-110.231H140.001v-45.383h633.692L663.462-611.923l31.614-31.999 164.923 164.537-164.538 164.922Z"></path>
              </svg>
            </a>
          </div>
        </div>
        <a class="col20 f-left t-center text-link-hover mt-15" on:click={() => onCancel(true)}>{M.MANAGE_ADDONS_BILLING}</a>
      </div>
    </div>
  {/if}
</div>
